import './icon-button.scss';

export default (props) => 
        <button type="button" className={`icon-button primary medium ${props.className}`} disabled={props.disabled} aria-label="Button label" style={props.style} onClick={props.onClick}>
            
        <span 

            className="icon medium" 
            data-theme="tui-light" 
            style={{
                
                WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`,
                maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`,
                color:"currentColor",
            }}
            >
  </span>
  {props.label}
</button>